export default {
  Date: /^(\d{2})-(\d{2})-(\d{4})$/,
  Percentage: /^(\d+),(\d{2})$/,
  Initials: /^([A-Z]\W)+$/
};
